module.exports = __webpack_public_path__ + "static/media/Manual-de-Politicas-de-Privacidad-Web.adb1e761.pdf";